import React from 'react';
import {translateKey} from "./values";

export const DataTableLocalization = {};
export const getDataTableLocalization = function () {
    return {
        pagination: {
            labelDisplayedRows: `{from}-{to} ${translateKey('from')} {count}`,
            labelRowsSelect: translateKey('labelRowsSelect'),
            labelRowsPerPage: translateKey('labelRowsPerPage'),
            firstAriaLabel: translateKey('firstAriaLabel'),
            firstTooltip: translateKey('firstTooltip'),
            previousAriaLabel: translateKey('previousAriaLabel'),
            previousTooltip: translateKey('previousTooltip'),
            nextAriaLabel:translateKey('nextAriaLabel'),
            nextTooltip: translateKey('nextTooltip'),
            lastAriaLabel: translateKey('lastAriaLabel'),
            lastTooltip: translateKey('lastTooltip'),
        },
        toolbar: {
            nRowsSelected: `{0} ${translateKey('rowsSelected')}`,
            searchTooltip: translateKey('search'),
            searchPlaceholder: translateKey('search'),
            exportTitle: translateKey('exportTitle'),
            exportAriaLabel: translateKey('exportCSVName'),
            exportCSVName: translateKey('exportCSVName'),
            exportPDFName: "",

        },
        header: {
            actions: ""
        },
        body: {
            emptyDataSourceMessage: translateKey('emptyDataSourceMessage'),
            addTooltip: translateKey('addTooltip'),
            deleteTooltip:translateKey('deleteTooltip'),
            editTooltip: translateKey('editTooltip'),

            filterRow: {
                filterTooltip:translateKey('filterTooltip'),
            },
            editRow:{
                deleteText: translateKey('deleteText'),
                cancelTooltip: translateKey('cancelTooltip'),
                saveTooltip: translateKey('saveTooltip'),
            }
        }
    };
}
